<template>
  <v-container class="grey lighten-5">
    <v-row class="justify-start">
      <div class="accordeon-container">
        <div
          v-if="isNotMultibank"
          class="
            d-flex
            flex-row
            align-center
            justify-space-around
            px-5
            py-2
            mt-3
          "
        >
          <div v-if="paymentMethodType != 'pix'">
            <div class="d-flex flex-column align-start justify-center">
              <p class="ma-0 f-990 color-darkGray">
                {{ paymentMethodType === 'sepa_account' ? 'Nome' : 'Número' }}
              </p>
              <div class="d-flex flex-row align-center justify-center">
                <p
                  v-if="paymentMethodType === 'sepa_account'"
                  class="
                    ma-0
                    f-12
                    primary--text
                    font-weight-medium
                    valor-cartao
                  "
                >
                  {{ maskName(selectedTypePaymentMethod.account_name) }}
                </p>
                <p
                  v-if="paymentMethodType === 'credit_card'"
                  class="
                    ma-0
                    f-12
                    primary--text
                    font-weight-medium
                    valor-cartao
                  "
                >
                  {{
                    `**** ${selectedTypePaymentMethod.number.substring(20, 14)}`
                  }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-column align-start justify-center">
              <p class="ma-0 f-990 color-darkGray">
                {{ paymentMethodType === 'sepa_account' ? 'IBAN' : 'Validade' }}
              </p>
              <p
                v-if="paymentMethodType === 'sepa_account'"
                class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
              >
                ****
                {{
                  selectedTypePaymentMethod.iban_code.substring(
                    selectedTypePaymentMethod.iban_code.length - 4,
                  )
                }}
              </p>
              <p
                v-if="paymentMethodType === 'credit_card'"
                class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
              >
                {{ selectedTypePaymentMethod.due_date }}
              </p>
            </div>
          </div>
          <div
            class="d-flex flex-column align-start justify-center"
            v-if="paymentMethodType === 'pix'"
          >
            <p class="ma-0 f-12 primary--text font-weight-medium valor-cartao">
              PIX selecionado
            </p>
            <p class="ma-0 f-990 color-darkGray">
              Envie o valor da consulta para essa chave pix:
              <strong>geral@ondivan.net</strong>
            </p>
          </div>
        </div>
        <div v-else>
          <div class="accordeon-container">
            <div
              class="
                d-flex
                flex-row
                align-center
                justify-space-between
                px-5
                py-2
                mt-3
              "
            >
              <div class="d-flex align-center">
                <h3 class="color-darkGray">Multibanco</h3>
              </div>
            </div>
            <p class="text-left px-5 py-2 mt-3 color-darkGray">
              Um Link para pagamento ficará disponível ao finalizar o
              agendamento.
            </p>
          </div>
        </div>
        <div class="d-flex justify-center">
          <v-btn
            @click="clearCard()"
            class="br-8 bg-darkGray color-white"
            height="40"
            small
          >
            ALTERAR FORMA DE PAGAMENTO
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    selectedTypePaymentMethod: { type: Object },
    paymentMethodType: { type: String },
  },
  computed: {
    isNotMultibank() {
      return this.paymentMethodType !== 'multibanco';
    },
  },
  methods: {
    clearCard() {
      this.$emit('clear');
    },
    maskName(name) {
      const nameList = name.split(' ');
      const endIndex = nameList.length - 1;
      return nameList
        .map((v, i) => {
          if (i == 0) {
            return v;
          }
          if (i === endIndex) {
            return (i = '...');
          }
          return `${String(v).charAt(0)}.`;
        })
        .join(' ');
    },
  },
};
</script>

<style>
.accordeon-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
</style>
